import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const UserStatusAction = ({ user, onDone }) => {
  const active = user.status === "active";
  const run = async () => {
    try {
      await api.post(`/admin/users/${user.id}/${active ? "disable" : "enable"}`);
      toast.success(active ? "Utente disabilitato" : "Utente riattivato");
      onDone();
    } catch (e) { toast.error(errorMessage(e)); }
  };
  if (!active) {
    return <Button size="sm" variant="outline" onClick={run} data-testid={`user-enable-button-${user.id}`}>Riattiva</Button>;
  }
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button size="sm" variant="outline" className="text-red-600 hover:text-red-700" data-testid={`user-disable-button-${user.id}`}>Disabilita</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Disabilitare {user.email}?</AlertDialogTitle>
          <AlertDialogDescription>L'utente non potrà più accedere e le sessioni attive verranno chiuse. Lo storico e i dati collegati restano conservati.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={run} className="bg-red-600 hover:bg-red-700" data-testid="user-disable-confirm-button">Disabilita</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
